import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BetweenDates, Payment, PaymentUpdate} from '../models/eventRequest';
import {environment} from './../../environments/environment';
import {DateService} from './date.service';
import {getStoreCodeByHostname} from '../driving-school.config';

const PAYMENT_API = environment.APIEndpoint + '/api/payments';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private dateService: DateService, private http: HttpClient) { }

  createPayment(paymentRequest: Payment): Observable<any> {
    return this.http.post(PAYMENT_API, paymentRequest, httpOptions);
  }

  updatePayment(paymentRequest: PaymentUpdate): Observable<any> {
    return this.http.put(PAYMENT_API, paymentRequest, httpOptions);
  }

  disabledPayment(paymentId: number): Observable<any> {
    return this.http.delete(PAYMENT_API + '/' + paymentId, httpOptions);
  }

  getPaymentsBetweenDates(dates: BetweenDates, page: number, size: number, sort: string = 'date,DESC'): Observable<any> {
    const datesString = this.dateService.getBetweenDatesString(dates);
    return this.http.post(PAYMENT_API + '/between-dates?page=' + page + '&size=' + size + '&sort=' + sort , datesString, httpOptions);
  }

  getTotalPaymentsBetweenDates(dates: BetweenDates): Observable<any> {
    const datesString = this.dateService.getBetweenDatesString(dates);
    return this.http.post(PAYMENT_API + '/total' , datesString, httpOptions);
  }

  getTotalGroupByPaymentsBetweenDates(dates: BetweenDates): Observable<any> {
    const datesString = this.dateService.getBetweenDatesString(dates);
    return this.http.post(PAYMENT_API + '/total-details' , datesString, httpOptions);
  }

  uploadInvoice(paymentId: bigint): Observable<any> {
    const storeCode = getStoreCodeByHostname(window.location.hostname);
    const headers = new HttpHeaders({
      'store-code': storeCode
    });

    return this.http.get(PAYMENT_API + '/' + paymentId + '/invoice', {
      headers,
      responseType: 'arraybuffer'
    });
  }

  uploadReceipt(paymentId: bigint): Observable<any> {
    const storeCode = getStoreCodeByHostname(window.location.hostname);
    const headers = new HttpHeaders({
      'store-code': storeCode
    });

    return this.http.get(PAYMENT_API + '/' + paymentId + '/receipt', {
      headers,
      responseType: 'arraybuffer'
    });
  }

  resetInvoiceNumbers(year?: number): Observable<any> {
    const params = year ? `?year=${year}` : '';
    return this.http.post(PAYMENT_API + '/reset-invoice-numbers' + params, {}, httpOptions);
  }
}
